/**
 * Slider Component
 *
 * @file slider.js
 */

import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination,Autoplay } from 'swiper/core';
SwiperCore.use([Navigation, Pagination,Autoplay]);

import 'swiper/swiper-bundle.css';
import $ from 'jquery';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    $("#homeSlide-video").each(function(){
        const vid = document.querySelectorAll("#homeSlide-video");
        for (var i = 0; i < vid.length; i++) {
          const j = i; // Create local copy
          vid[j].autoplay = "autoplay";
          vid[j].muted = true;  
          vid[j].play();
        }
    });
  };

  const CompartmentsSlider = () => {
    const swiperCompartment = new Swiper('.compartments-carousel', {
      slidesPerView: 3.7,
      spaceBetween: 20,
      loop:true,
      navigation: {
        nextEl: ".compartments-carousel-arrow-next",
        prevEl: ".compartments-carousel-arrow-prev ",
      },
      breakpoints: {
        0: {
          spaceBetween: 10,
          slidesPerView: 1.5,
          allowTouchMove: true,
          centeredSlides:true,
        },
        680: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3.7,
          spaceBetween: 20,
        },
      }
    });
  }

  const EatNeatSlider = () => {
    const swiperCompartment = new Swiper('.eat-meat-carousel', {
      slidesPerView: 2.5,
      spaceBetween: 150,
      centeredSlides:true,
      loop:true,
      navigation: {
        nextEl: ".eat-meat-carousel-arrow-next",
        prevEl: ".eat-meat-carousel-arrow-prev ",
      },
      breakpoints: {
        0: {
          spaceBetween: 10,
          slidesPerView: 1.1,
          allowTouchMove: true,
          centeredSlides:false,
        },
        680: {
          slidesPerView: 2,
          spaceBetween: 20,
          centeredSlides:true,
        },
        992: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1100: {
          slidesPerView: 2.5,
          spaceBetween: 150,
        },
      }
    });
  }

  const SuitDetailSlider = () => {
    const SuitDetailSlider = new Swiper('.suit-banner-carousel ', {
      slidesPerView: 2,
      spaceBetween: 40,
      centeredSlides:true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      loop:true,
      navigation: {
        nextEl: ".hm-sd-next",
        prevEl: ".hm-sd-prev ",
      },
      breakpoints: {
        0: {
          spaceBetween: 10,
          slidesPerView: 1.1,
          allowTouchMove: true,
          centeredSlides:false,
        },
        680: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          centeredSlides:true,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
      }
    });
  }

  const hkCarousel = () => {
    const hkCarousel = new Swiper('.dmt-hk-carousel', {
      slidesPerView: 3.4,
      spaceBetween: 60,
      centeredSlides:true,
      loop:true,
      navigation: {
        nextEl: ".dmt-hk-carousel-arrow-next",
        prevEl: ".dmt-hk-carousel-arrow-prev ",
      },
      breakpoints: {
        0: {
          spaceBetween: 10,
          slidesPerView: 1.1,
          allowTouchMove: true,
          centeredSlides:false,
        },
        680: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          centeredSlides:true,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1000: {
          slidesPerView: 2.4,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3.4,
          spaceBetween: 60,
        },
      }
    });
  }

  const hkThImCarousel = () => {
    const hkCarousel = new Swiper('.three-item-carousel', {
      slidesPerView: 2.8,
      spaceBetween: 120,
      loop:true,
      navigation: {
        nextEl: ".three-item-carousel-arrow-next",
        prevEl: ".three-item-carousel-arrow-prev ",
      },
      breakpoints: {
        0: {
          spaceBetween: 10,
          slidesPerView: 1.1,
          allowTouchMove: true,
          centeredSlides:false,
        },
        680: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          centeredSlides:true,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1000: {
          slidesPerView: 2.7,
          spaceBetween: 60,
        },
        1680: {
          slidesPerView: 2.8,
          spaceBetween: 120,
        },
      }
    });
  }

  const init = () => {
    fullSlider();
    CompartmentsSlider();
    EatNeatSlider();
    SuitDetailSlider();
    hkCarousel();
    hkThImCarousel();
  };

  return {
    init,
  };
})();

export default slider;
